import { useField } from "remix-validated-form";
import { ExclamationCircleIcon } from '@heroicons/react/solid'
import { classNames } from "~/utils";

type InputProps = {
    name: string;
    label: string;
    className?: string;
    desc?: string;
};

export default ({ name, desc, label, className }: InputProps) => {
    const { error, getInputProps } = useField(name);
    return (
        <div className={classNames(className)}>
            <label htmlFor={name} className="block text-sm font-medium text-gray-700">{label}</label>
            <div className="relative mt-1 rounded-md">
                <textarea {...getInputProps({ id: name })}
                    rows={3}
                    className={error ? 
                        "block w-full rounded-md border-red-300 pr-10 text-red-900 placeholder-red-300 focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm" : 
                        "block w-full rounded-md border-gray-300 shadow-sm focus:border-pcolor-400 focus:ring-pcolor-400 sm:text-sm"}
                />
                {desc && <p id="phone-description" className="text-gray-400 text-sm mt-1">
                    {desc}
                </p>}
                {error && (<div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <ExclamationCircleIcon className="w-5 h-5 text-red-500" aria-hidden="true" />
                </div>)}
            </div>
            {error && (<p className="mt-2 text-sm text-red-600" id="email-error">
                {error}
            </p>)}
        </div>
    );
};